/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import { mixin } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import GSuiteApi from 'client/api/v2/GSuiteApi';
import SudoMixin from 'client/store/mixins/SudoMixin';

export class GsuiteDetailsCollectionClass extends CollectionModule {
  /**
   * Override method from base class to add GSuite specific fields to the Vuex
   * module entities and features.
   */
  extractModule() {
    const module = super.extractModule();

    mixin(module.actions, SudoMixin.actions);

    module.actions.listDomains = (...params) => this.listDomains(...params);
    module.actions.listSelectedDomains = (...params) => this.listSelectedDomains(...params);
    return module;
  }
  // ----------------------------------------------------------------------------------------------
  // Actions
  // ----------------------------------------------------------------------------------------------

  listDomains(context, item) {
    return GSuiteApi.listDomains(item.id);
  }

  listSelectedDomains(context, item) {
    return GSuiteApi.listSelectedDomains(item.id);
  }
}

export default new GsuiteDetailsCollectionClass(GSuiteApi, 'id', '').extractModule();
